import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { ENTITY_SLUG_FIELD_NAME } from '@cli-constants/schema.js'

export function isEntitySlugField(field: SchemaField): boolean {
  return field.name === ENTITY_SLUG_FIELD_NAME
}
